/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Activity_Total_AppliedInputs */

const en_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total Applied`)
};

const de_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gesamt beworben`)
};

const fr_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total postulé`)
};

const es_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total postulado`)
};

const it_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totale candidature`)
};

const nl_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totaal gesolliciteerd`)
};

const pl_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Łącznie aplikacji`)
};

const fi_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yhteensä haettu`)
};

const da_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ansøgt i alt`)
};

const sv_analytics_activity_total_applied = /** @type {(inputs: Analytics_Activity_Total_AppliedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Totalt ansökt`)
};

/**
* | output |
* | --- |
* | "Total Applied" |
*
* @param {Analytics_Activity_Total_AppliedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const analytics_activity_total_applied = /** @type {((inputs?: Analytics_Activity_Total_AppliedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Activity_Total_AppliedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_analytics_activity_total_applied(inputs)
	if (locale === "fr") return fr_analytics_activity_total_applied(inputs)
	if (locale === "es") return es_analytics_activity_total_applied(inputs)
	if (locale === "it") return it_analytics_activity_total_applied(inputs)
	if (locale === "nl") return nl_analytics_activity_total_applied(inputs)
	if (locale === "pl") return pl_analytics_activity_total_applied(inputs)
	if (locale === "fi") return fi_analytics_activity_total_applied(inputs)
	if (locale === "da") return da_analytics_activity_total_applied(inputs)
	if (locale === "sv") return sv_analytics_activity_total_applied(inputs)
	return en_analytics_activity_total_applied(inputs)
});